const btn = document.querySelector('.header-wrapper--overlay')
const options = {
  attributes: true
}

function callback(mutationList, observer) {
  mutationList.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      // handle class change
      if (btn.classList.contains("stuck")) {
        document.body.classList.remove('search-opened');
      }
      else if(btn.classList.contains("unstuck")){
        document.body.classList.add('search-opened');
      }
    }
  })
}

const observer = new MutationObserver(callback)
observer.observe(btn, options)